import { PolicyPageLayout } from '@/components/ui/PolicyPageLayout';
import { subscriptionRefundPolicy } from '@/content/policies';

export function SubscriptionInfo() {
  return (
    <PolicyPageLayout
      title="Subscription Information & Refund Policy"
      blocks={subscriptionRefundPolicy}
    />
  );
}
